import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button } from 'antd';
import Toast from 'antd-mobile/lib/toast';
import './UpdateGuideDocument.css';

const { TextArea } = Input;

@inject('guideDocumentStore')
@observer
class UpdateGuideDocumentModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    createGuideDocumentOnClick = () => {
        this.props.guideDocumentStore.createGuideDocument();
    }

    updateGuideDocumentOnClick = () => {
        this.props.guideDocumentStore.updateGuideDocument();
    }

    cancelGuideDocumentOnClick = () => {
        this.props.guideDocumentStore.setShowUpdateGuideDocumentModal(false);
    }

    render() {
        const {
            guideDocumentID,
            title,
            url,
            updateLoading
        } = this.props.guideDocumentStore;

        const hasError = title !== '' && url !== '';

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <Form layout='vertical'>
                <Form.Item label='Guide Document Title' className='mg-b-10'>
                    <TextArea rows={3} maxLength={100} placeholder='Insert title here' value={title} onChange={(e) => this.props.guideDocumentStore.setTitle(e.target.value)}></TextArea>
                </Form.Item>

                <Form.Item label='Guide Document URL' className='mg-b-10'>
                    <TextArea rows={3} maxLength={100} placeholder='Insert url here' value={url} onChange={(e) => this.props.guideDocumentStore.setUrl(e.target.value)}></TextArea>
                </Form.Item>

                <Form.Item>
                    {
                        guideDocumentID === 0 ? (
                            <Button onClick={this.createGuideDocumentOnClick} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>Create</Button>
                        ) : (
                            <Button onClick={this.updateGuideDocumentOnClick} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>Update</Button>
                        )
                    }

                    <Button onClick={this.cancelGuideDocumentOnClick}>Cancel</Button>
                </Form.Item>
            </Form>
        )
    }
}

export default UpdateGuideDocumentModal;